import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Chip } from '@mui/material';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useAuthenticator } from '@aws-amplify/ui-react';

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuthenticator((context) => [context.user]);
    const apiEndpoint = Amplify.getConfig().API.REST.dnaAdminApi.endpoint;

    console.log('Inspeccionando config de Amplify:', Amplify.getConfig());

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setLoading(true);
                const session = await fetchAuthSession();
                const idToken = session.tokens?.idToken?.toString();
                if (!idToken) {
                    throw new Error('No se encontró el token de autenticación.');
                }
                const response = await fetch(`${apiEndpoint}/admin/customers`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': idToken
                    }
                });
                if (!response.ok) {
                    throw new Error(`Error de red: ${response.status} ${response.statusText}`);
                }
                const responseJson = await response.json();
                if (responseJson.success) {
                    setUsers(responseJson.data);
                } else {
                    throw new Error(responseJson.msg || 'Error en la respuesta de la API');
                }
            } catch (err) {
                console.error('Error fetching users:', err);
                setError('No se pudieron cargar los usuarios.');
            } finally {
                setLoading(false);
            }
        };

        if (user) {
            fetchUsers();
        }
    }, [user, apiEndpoint]);

    const getStatusChip = (status) => {
        switch (status) {
            case 'ACTIVE':
                return <Chip label="Activo" color="success" size="small" />;
            case 'TRIAL':
                return <Chip label="Prueba" color="info" size="small" />;
            case 'INACTIVE':
                return <Chip label="Inactivo" color="warning" size="small" />;
            default:
                return <Chip label={status} size="small" />;
        }
    };

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <TableContainer component={Paper}>
            <Typography variant="h5" sx={{ p: 2 }}>Gestión de Clientes</Typography>
            <Table sx={{ minWidth: 650 }} aria-label="tabla de clientes">
                <TableHead>
                    <TableRow>
                        <TableCell>Nombre Empresa</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Fecha de Registro</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user) => (
                        <TableRow key={user.userId}>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{getStatusChip(user.subscriptionStatus)}</TableCell>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default UserManagement;